export default [{
  text: 'Blocker',
  value: 'blocker',
  color: 'red',
  dark: true,
  icon: 'mdi-palette',
}, {
  text: 'Major',
  value: 'major',
  color: '#ff7468',
  dark: true,
  icon: 'mdi-palette',
}, {
  text: 'Medium',
  value: 'medium',
  color: '#6e82ed',
  dark: true,
  icon: 'mdi-palette',
}, {
  text: 'Minor',
  value: 'minor',
  color: '#27c1d5',
  dark: true,
  icon: 'mdi-palette',
}];
